module.exports = __webpack_public_path__ + "static/media/TVH.7ff98f83.png";